module.exports = __webpack_public_path__ + "../assets/img/7f590e90d63eed5185d5331d54247cff.svg";